import { CommandRight } from "../../../Syntess.Web.Shared/CommandRight";
import { ActionId } from "../../Scripts/Project/ActionId";

export enum Label {
    Gegevens = "Gegevens tonen",
    Menu = "Tonen als menukeuze",
    Facturen = "Facturen",
    Bonnen = "Bonnen",
    StoringMelden = "Storing melden",
    Afspraken = "Afspraken",
    Installaties = "Installaties",
    FGas = "F-gas",
    PED = "PED",
    RVB = "Registratie van beheer",
    Objecten = "Objecten",
    Correspondentie = "Correspondentie",
    Bestanden = "Bestanden"
}

export enum RechtengroepRechtType {
    User = 'U',
    Group = 'G'
}

export class RechtengroepRecht {
    constructor(
        public ActionId: ActionId,
        public OpenType: RechtengroepRechtType,
        public AddType: RechtengroepRechtType | null = null
    ) { }
}

/**
* Verzameling van alle rechten van een rechtengroep.
*/
export class RechtengroepRechten {
    private rechten: RechtengroepRecht[];

    constructor(rechten: RechtengroepRecht[]) {
        this.rechten = rechten || [];
    }

    public GetRecht(actionId: ActionId): RechtengroepRecht | null {
        let results = this.rechten.filter(x => x.ActionId == actionId);
        if (results.length) {
            return results[0];
        } else {
            return null;
        }
    }

    /**
     * Get het opentype van een recht op basis het ActionId.
     * @param actionId Het ActionId
     */
    public GetOpenType(actionId: ActionId): RechtengroepRechtType | null {
        let recht = this.GetRecht(actionId);
        if (recht) {
            return recht.OpenType;
        }
        return null;
    }

    /**
     * Get het addtype van een recht op basis van het ActionId.
     * @param actionId Het ActionId
     */
    public GetAddType(actionId: ActionId): RechtengroepRechtType | null {
        let recht = this.GetRecht(actionId);
        if (recht) {
            return recht.AddType;
        }
        return null;
    }
}

/**
* Geeft een computed observable die de rechtenboom opstelt tbv het rechtengroep instelscherm.
* @param viewModel Het viewmodel
*/
export function GetRechtenboomComputed(viewModel: { rechten: KnockoutObservable<RechtengroepRechten | null> }) {
    return ko.computed(function () {
        let boom: any = {
            Facturen: null,
            Bonnen: null,
            Afspraken: null,
            Installaties: null,
            Objecten: null,
            Correspondentie: null,
            Bestanden: null
        };

        let rechten: RechtengroepRechten | null = viewModel.rechten();
        if (rechten) {
            let facturenGegevens = rechten.GetRecht(ActionId.PortalGegevensFacturen);
            if (facturenGegevens) {
                boom.Facturen = { Gegevens: ko.observable(facturenGegevens.OpenType == RechtengroepRechtType.Group) };

                let facturenMenu = rechten.GetRecht(ActionId.PortalMenuFacturen);
                if (facturenMenu) {
                    boom.Facturen.Menu = ko.observable(facturenMenu.OpenType == RechtengroepRechtType.Group);
                    boom.Facturen.Menu.subscribe(function (newValue: any) {
                        if (newValue) {
                            boom.Facturen.Gegevens(true);
                        }
                    });
                }
            }

            let bonnenGegevens = rechten.GetRecht(ActionId.PortalGegevensWerkbonnen);
            if (bonnenGegevens) {
                boom.Bonnen = { Gegevens: ko.observable(bonnenGegevens.OpenType == RechtengroepRechtType.Group) };

                let bonnenMenu = rechten.GetRecht(ActionId.PortalMenuBonnen);
                if (bonnenMenu) {
                    boom.Bonnen.Menu = ko.observable(bonnenMenu.OpenType == RechtengroepRechtType.Group);
                    boom.Bonnen.Menu.subscribe(function (newValue: any) {
                        if (newValue) {
                            boom.Bonnen.Gegevens(true);
                        }
                    });
                }

                if (bonnenGegevens.AddType) {
                    boom.Bonnen.StoringMelden = ko.observable(bonnenGegevens.AddType == RechtengroepRechtType.Group);
                    boom.Bonnen.StoringMelden.subscribe(function (newValue: any) {
                        if (newValue) {
                            boom.Bonnen.Gegevens(true);
                        }
                    });
                }
            }

            let afsprakenGegevens = rechten.GetRecht(ActionId.PortalGegevensAfspraken);
            if (afsprakenGegevens) {
                boom.Afspraken = { Gegevens: ko.observable(afsprakenGegevens.OpenType == RechtengroepRechtType.Group) };

                let afsprakenMenu = rechten.GetRecht(ActionId.PortalMenuAfspraken);
                if (afsprakenMenu) {
                    boom.Afspraken.Menu = ko.observable(afsprakenMenu.OpenType == RechtengroepRechtType.Group);
                    boom.Afspraken.Menu.subscribe(function (newValue: any) {
                        if (newValue) {
                            boom.Afspraken.Gegevens(true);
                        }
                    });
                }
            }
            let installatiesGegevens = rechten.GetRecht(ActionId.PortalGegevensInstallaties);
            if (installatiesGegevens) {
                boom.Installaties = { Gegevens: ko.observable(installatiesGegevens.OpenType == RechtengroepRechtType.Group) };

                let installatiesMenu = rechten.GetRecht(ActionId.PortalMenuInstallaties);
                if (installatiesMenu) {
                    boom.Installaties.Menu = ko.observable(installatiesMenu.OpenType == RechtengroepRechtType.Group);
                    boom.Installaties.Menu.subscribe(function (newValue: any) {
                        if (newValue) {
                            boom.Installaties.Gegevens(true);
                        }
                    });
                }

                let installatiesFGas = rechten.GetRecht(ActionId.PortalGegevensInstalKoeling);
                if (installatiesFGas) {
                    boom.Installaties.FGas = ko.observable(installatiesFGas.OpenType == RechtengroepRechtType.Group);
                    boom.Installaties.FGas.subscribe(function (newValue: any) {
                        if (newValue) {
                            boom.Installaties.Gegevens(true);
                        }
                    });
                }

                let installatiesPED = rechten.GetRecht(ActionId.PortalGegevensInstalPED);
                if (installatiesPED) {
                    boom.Installaties.PED = ko.observable(installatiesPED.OpenType == RechtengroepRechtType.Group);
                    boom.Installaties.PED.subscribe(function (newValue: any) {
                        if (newValue) {
                            boom.Installaties.Gegevens(true);
                        }
                    });
                }

                let installatiesRVB = rechten.GetRecht(ActionId.PortalGegevensInstallatiesRVB);
                if (installatiesRVB) {
                    boom.Installaties.RVB = ko.observable(installatiesRVB.OpenType == RechtengroepRechtType.Group);
                    boom.Installaties.RVB.subscribe(function (newValue: any) {
                        if (newValue) {
                            boom.Installaties.Gegevens(true);
                        }
                    });
                }
            }
            let objectenGegevens = rechten.GetRecht(ActionId.PortalGegevensObjecten);
            if (objectenGegevens) {
                boom.Objecten = { Gegevens: ko.observable(objectenGegevens.OpenType == RechtengroepRechtType.Group) };

                let objectenMenu = rechten.GetRecht(ActionId.PortalMenuObjecten);
                if (objectenMenu) {
                    boom.Objecten.Menu = ko.observable(objectenMenu.OpenType == RechtengroepRechtType.Group);
                    boom.Objecten.Menu.subscribe(function (newValue: any) {
                        if (newValue) {
                            boom.Objecten.Gegevens(true);
                        }
                    });
                }
            }
            let correspondentieGegevens = rechten.GetRecht(ActionId.PortalGegevensBrieven);
            if (correspondentieGegevens) {
                boom.Correspondentie = { Gegevens: ko.observable(correspondentieGegevens.OpenType == RechtengroepRechtType.Group) };

                let correspondentieMenu = rechten.GetRecht(ActionId.PortalMenuCorrespondentie);
                if (correspondentieMenu) {
                    boom.Correspondentie.Menu = ko.observable(correspondentieMenu.OpenType == RechtengroepRechtType.Group);
                    boom.Correspondentie.Menu.subscribe(function (newValue: any) {
                        if (newValue) {
                            boom.Correspondentie.Gegevens(true);
                        }
                    });
                }
            }
            let bestandenGegevens = rechten.GetRecht(ActionId.PortalGegevensBestanden);
            if (bestandenGegevens) {
                boom.Bestanden = { Gegevens: ko.observable(bestandenGegevens.OpenType == RechtengroepRechtType.Group) };
            }
        }
        return boom;
    });
}

export function VerwerkRechtenboom(rechtenboom: any) {
    function AddItem(rechten: any[], actionId: ActionId, commandRights: CommandRight[]) {
        rechten.push({ ActionId: actionId, CommandRights: commandRights });
    }

    let rechten: any[] = [];
    if (rechtenboom.Facturen) {
        if (rechtenboom.Facturen.Gegevens()) {
            AddItem(rechten, ActionId.PortalGegevensFacturen, [CommandRight.Open]);

            if (rechtenboom.Facturen.Menu && rechtenboom.Facturen.Menu()) {
                AddItem(rechten, ActionId.PortalMenuFacturen, [CommandRight.Open]);
            }
        }
    }

    if (rechtenboom.Bonnen) {
        if (rechtenboom.Bonnen.Gegevens()) {
            AddItem(rechten, ActionId.PortalGegevensWerkbonnen, [CommandRight.Open]);

            if (rechtenboom.Bonnen.Menu && rechtenboom.Bonnen.Menu()) {
                AddItem(rechten, ActionId.PortalMenuBonnen, [CommandRight.Open]);
            }
            if (rechtenboom.Bonnen.StoringMelden && rechtenboom.Bonnen.StoringMelden()) {
                AddItem(rechten, ActionId.PortalGegevensWerkbonnen, [CommandRight.Add]);
            }
        }
    }

    if (rechtenboom.Afspraken) {
        if (rechtenboom.Afspraken.Gegevens()) {
            AddItem(rechten, ActionId.PortalGegevensAfspraken, [CommandRight.Open]);

            if (rechtenboom.Afspraken.Menu && rechtenboom.Afspraken.Menu()) {
                AddItem(rechten, ActionId.PortalMenuAfspraken, [CommandRight.Open]);
            }
        }
    }

    if (rechtenboom.Installaties) {
        if (rechtenboom.Installaties.Gegevens()) {
            AddItem(rechten, ActionId.PortalGegevensInstallaties, [CommandRight.Open]);

            if (rechtenboom.Installaties.Menu && rechtenboom.Installaties.Menu()) {
                AddItem(rechten, ActionId.PortalMenuInstallaties, [CommandRight.Open]);
            }

            if (rechtenboom.Installaties.FGas && rechtenboom.Installaties.FGas()) {
                AddItem(rechten, ActionId.PortalGegevensInstalKoeling, [CommandRight.Open]);
            }

            if (rechtenboom.Installaties.PED && rechtenboom.Installaties.PED()) {
                AddItem(rechten, ActionId.PortalGegevensInstalPED, [CommandRight.Open]);
            }

            if (rechtenboom.Installaties.RVB && rechtenboom.Installaties.RVB()) {
                AddItem(rechten, ActionId.PortalGegevensInstallatiesRVB, [CommandRight.Open]);
            }
        }
    }

    if (rechtenboom.Objecten) {
        if (rechtenboom.Objecten.Gegevens()) {
            AddItem(rechten, ActionId.PortalGegevensObjecten, [CommandRight.Open]);

            if (rechtenboom.Objecten.Menu && rechtenboom.Objecten.Menu()) {
                AddItem(rechten, ActionId.PortalMenuObjecten, [CommandRight.Open]);
            }
        }
    }

    if (rechtenboom.Correspondentie) {
        if (rechtenboom.Correspondentie.Gegevens()) {
            AddItem(rechten, ActionId.PortalGegevensBrieven, [CommandRight.Open]);

            if (rechtenboom.Correspondentie.Menu && rechtenboom.Correspondentie.Menu()) {
                AddItem(rechten, ActionId.PortalMenuCorrespondentie, [CommandRight.Open]);
            }
        }
    }

    if (rechtenboom.Bestanden) {
        if (rechtenboom.Bestanden.Gegevens()) {
            AddItem(rechten, ActionId.PortalGegevensBestanden, [CommandRight.Open]);
        }
    }

    return rechten;
}
